import React from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { Box } from '@mui/material'

const useStyles = makeStyles((theme) => ({
  twitterBox: {
    minHeight: 150,
    position: 'relative',
    fontFamily: "'Dosis', sans-serif",
    fontWeight: 800,
    backgroundColor: '#fff',
    zIndex: 11,
    '& .header': {
      backgroundColor: '#FFDAEC',
      borderRadius: '8px',
      padding: '8px',
      color: '#2B1C2F',
      display: 'flex',
      alignItems: 'center',
      '& img': {
        width: '64px',
      },
      '& span': {
        fontSize: '24px',
        marginLeft: '12px',
      },
    },
    '& .content': {
      padding: '0 5%',
    },
  },
  [theme.breakpoints.up('sm')]: {
    twitterBox: {
      minHeight: 150,
      '& .header': {
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        '& img': {
          width: '128px',
        },
        '& span': {
          fontSize: '36px',
          marginLeft: '24px',
        },
      },
      '& .content': {
        padding: '0 5%',
      },
    },
  },
}))

const LastetTweet = ({ account }) => {
  const classes = useStyles()
  const twitterUrl = `https://twitter.com/${account}`
  return (
    <Box className={classes.twitterBox}>
      <Box className="header">
        <img src="/images/maintenance.svg" alt="maintenance" />
        <span>Official Announcement</span>
      </Box>
      <Box className="content">
        <a className="twitter-timeline" href={twitterUrl} data-tweet-limit="1" data-width="100%">
          &nbsp;
        </a>
      </Box>
    </Box>
  )
}

export default LastetTweet
